import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h3 className="text-lg font-heading font-bold text-background-50 mb-4">草榴技术讨论区</h3>
            <p className="text-sm text-background-400 leading-relaxed">
              专注技术交流的核心社区板块，汇聚技术爱好者分享编程、网络、工具使用等实用经验。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-heading font-semibold text-background-100 mb-4">技术分类</h3>
            <ul className="space-y-2">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-heading font-semibold text-background-100 mb-4">快捷入口</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">首页</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">关于我们</Link>
              </li>
              <li>
                <a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">社区规范</a>
              </li>
              <li>
                <a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">帮助中心</a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-heading font-semibold text-background-100 mb-4">联系我们</h3>
            <ul className="space-y-2 text-sm text-background-400">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line"></i>
                <span>contact@caoliu-tech.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line"></i>
                <span>中国·北京</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; 2026 草榴技术讨论区 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors whitespace-nowrap cursor-pointer">隐私政策</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors whitespace-nowrap cursor-pointer">服务条款</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors whitespace-nowrap cursor-pointer" rel="nofollow">RSS订阅</a>
          </div>
        </div>
      </div>
    </footer>
  );
}